import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';

export interface EditReturnItemData {
  productId: number;
  name: string;
  code?: string;
  quantity: number;
  price: number;
  reason: string;
}

@Component({
  selector: 'app-edit-return-item-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule
  ],
  templateUrl: './edit-return-item-dialog-component.html',
  styleUrls: ['./edit-return-item-dialog-component.scss']
})
export class EditReturnItemDialogComponent {
  reasons: string[] = ['Good Return', 'Damaged', 'Expired', 'Due'];

  constructor(
    public dialogRef: MatDialogRef<EditReturnItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditReturnItemData
  ) { }

  save(): void {
    this.dialogRef.close(this.data);
  }

  deleteItem(): void {
    this.dialogRef.close({ delete: true });
  }

  increaseQuantity(): void {
    this.data.quantity++;
  }

  decreaseQuantity(): void {
    if (this.data.quantity > 0) {
      this.data.quantity--;
    }
  }
}

